import React from 'react'
import PropTypes from 'prop-types'
import { Trans } from 'gatsby-plugin-react-i18next'
import {
  Subheader,
  FrameProductOptions,
  ButtonContainer,
} from 'src/components/FrameProductForm/styles'
import {
  ColorSelectionContainer,
  SubLabel,
  StyleOptionsContainer,
  ComingSoonDisclosure,
} from 'src/templates/CalendarProductPage/styles'
import {
  RightGrid,
  StyleSelectionContainer,
  CTAContainer,
} from '../../templates/SnapFramePage/styles.js'
import ColorSelectionItem from '../ColorSelectionItem'
import StyleOption from '../StyleOption'
import QuantitySelection from '../QuantitySelection'
import AddToCartButton from '../AddToCartButton'
import {
  CAL_2_STYLE_OOS,
  FRAME_2_STYLE_OOS,
} from '../../templates/CalendarProductPage/styleConfig.js'

const Frame2ColorSelection = ({
  style,
  color,
  handleStyleSelection,
  handleColorSelection,
  styleConfig,
  stylesOrder,
  scrollableStylesContainerRef,
  OOS,
  quantityVal,
  decrementQuantity,
  incrementQuantity,
  submitting,
  handleAddToCart,
  shopifyId,
  plp,
  isCalendar,
}) => (
  <RightGrid plp={plp}>
    {!isCalendar && (
      <Subheader>
        <Trans>Select Your Style and color</Trans>
      </Subheader>
    )}
    <StyleSelectionContainer ref={scrollableStylesContainerRef}>
      <StyleOptionsContainer>
        {styleConfig &&
          Object.keys(styleConfig).length > 0 &&
          stylesOrder.map((styleKey, i) => (
            <StyleOption
              key={`${styleKey}-${color}-${i}`}
              style={styleKey}
              color={color}
              isSelected={style === styleKey}
              handleSelection={(selectedStyle) => {
                if (style !== selectedStyle) {
                  handleStyleSelection(selectedStyle)
                }
              }}
              smallRadio
              plp={plp}
              isCalendar={isCalendar}
            />
          ))}
      </StyleOptionsContainer>
    </StyleSelectionContainer>
    <SubLabel />
    {isCalendar && (
      <SubLabel>
        <Trans>Select your color</Trans>
      </SubLabel>
    )}
    <FrameProductOptions>
      {Object.keys(styleConfig[style].image).map((colorKey, i) => (
        <ColorSelectionContainer
          isSelected={color === colorKey}
          is15
          key={`wrapper-${colorKey}-${i}`}
        >
          <ColorSelectionItem
            variant={colorKey}
            onSelectColor={() => handleColorSelection(colorKey)}
            isOutOfStock={
              isCalendar ? CAL_2_STYLE_OOS[style]?.[colorKey] : FRAME_2_STYLE_OOS[style]?.[colorKey]
            }
            isSelected={color === colorKey}
            isCalendar
            mediumRadio
          />
          <ComingSoonDisclosure visable={OOS && color === colorKey}>
            Out of Stock
          </ComingSoonDisclosure>
        </ColorSelectionContainer>
      ))}
    </FrameProductOptions>
    {!isCalendar && (
      <QuantitySelection
        quantityVal={quantityVal}
        decrementQuantity={decrementQuantity}
        incrementQuantity={incrementQuantity}
      />
    )}
    <CTAContainer plp={plp}>
      <ButtonContainer className="regular-cta">
        <AddToCartButton
          label="Add to Cart"
          adding={submitting}
          handleClick={() => handleAddToCart(shopifyId, quantityVal)}
          oos={false}
        />
      </ButtonContainer>
    </CTAContainer>
  </RightGrid>
)

Frame2ColorSelection.propTypes = {
  style: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  handleStyleSelection: PropTypes.func.isRequired,
  handleColorSelection: PropTypes.func.isRequired,
  styleConfig: PropTypes.object.isRequired,
  stylesOrder: PropTypes.array.isRequired,
  scrollableStylesContainerRef: PropTypes.object.isRequired,
  OOS: PropTypes.bool.isRequired,
  quantityVal: PropTypes.number.isRequired,
  decrementQuantity: PropTypes.func.isRequired,
  incrementQuantity: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  handleAddToCart: PropTypes.func.isRequired,
  shopifyId: PropTypes.string.isRequired,
  plp: PropTypes.bool,
  isCalendar: PropTypes.bool,
}

export default Frame2ColorSelection
